import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';

export const DefaultWarning = () => (
  <Typography variant="paragraph4" color="pebble">
    By clicking “Continue”, you accept Evite’s{' '}
    <Link
      href="/content/terms"
      title="terms of service"
      target="_blank"
      data-qa-id="link-terms"
      thickness="thin"
      className="RSVP-modal__terms-and-privacy"
    >
      Terms of Service
    </Link>{' '}
    &{' '}
    <Link
      href="/content/privacy_policy"
      title="privacy policy"
      target="_blank"
      data-qa-id="link-privacy"
      thickness="thin"
      className="RSVP-modal__terms-and-privacy"
    >
      Privacy Policy
    </Link>
    .
  </Typography>
);
